import { useEffect, useMemo } from 'react'
import { createIncomingCallRingtonePlayer } from '@/lib/incomingCallRingtone'
import { useCallStore } from '@/store/callStore'

export function useIncomingCallRingtone() {
  const incomingOrderID = useCallStore((state) => state.incomingCall?.order_id || null)
  const currentOrderID = useCallStore((state) => state.currentCall?.order_id || null)
  const player = useMemo(() => createIncomingCallRingtonePlayer(), [])

  useEffect(() => {
    if (incomingOrderID && currentOrderID !== incomingOrderID) {
      player.start(incomingOrderID)
      return
    }
    player.stop()
  }, [currentOrderID, incomingOrderID, player])

  useEffect(() => () => {
    player.destroy()
  }, [player])
}
